<template>
    <import-upload
        import-type="campaign"
        :page-subtitle="selectedCampaign.name"
        path-prefix="campaigns"
        @cancel="onCancel"
        @upload="onUpload"
    />
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import ImportUpload from '@/views/Imports/ImportUpload.vue';

    export default {
        components: { ImportUpload },

        computed: {
            ...mapState('campaign', [
                'selectedCampaign',
            ]),
        },

        methods: {
            ...mapMutations('campaign', [
                'clearSelectedCampaign',
            ]),

            onCancel() {
                this.$router.push({
                    name: 'campaign',
                    params: {
                        id: this.selectedCampaign.id,
                    },
                });
            },

            onUpload(importId) {
                this.$router.push({
                    name: 'campaigns.import.match',
                    params: {
                        id: importId,
                        campaignId: this.$route.params.campaignId,
                    },
                });
            },
        },


        beforeRouteLeave(to, from, next) {
            if (to.name != 'campaigns.import.match') {
                this.clearSelectedCampaign();
            }

            next();
        },
    };
</script>
